import React from "react";
import Fade from "react-reveal/Fade";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import VerificaToken from "../../components/VerificaToken";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import axios from "axios";

function ModificaPassword() {
  let history = useHistory();

  const { user, setUser } = VerificaToken();

  const initialValues = {
    vecchiaPassword: "",
    nuovaPassword: "",
  };

  const validationSchema = Yup.object().shape({
    vecchiaPassword: Yup.string()
      .required("Devi compilare questo campo!")
      .min(5, "Valore non valido: Troppo corto!")
      .max(20, "Valore non valido: Troppo lungo!"),
    nuovaPassword: Yup.string()
      .required("Devi compilare questo campo!")
      .min(5, "Valore non valido: Troppo corto!")
      .max(20, "Valore non valido: Troppo lungo!"),
  });

  const onSubmit = (data) => {
    axios
      .put(
        `https://website-8bit-motors.herokuapp.com/account/info/${user.id}/modificaPassword`,
        data
      )
      .then((response) => {
        if (response.data.error) {
          alert(response.data.error);
        } else {
          axios
            .get(
              `https://website-8bit-motors.herokuapp.com/account/info/${user.id}`
            )
            .then((res) => {
              setUser(res.data);
              history.push(`/account/info/${user.id}`);
            });
        }
      });
  };

  return (
    <Container fluid>
      {/* SEZIONE BANNER */}
      <Container
        fluid
        id="banner_recovered"
        className="head-banner text-center text-white"
      >
        <Container>
          <Row>
            <Col>
              <h1>
                <strong>8-Bit Motors</strong>
              </h1>
            </Col>
          </Row>
        </Container>
      </Container>

      <Container className="text-center">
        <h2 className="mt-3">Modifica Password</h2>
        <Formik
          onSubmit={onSubmit}
          initialValues={initialValues}
          validationSchema={validationSchema}
        >
          <Form>
            <Row>
              <Col>
                <Fade left>
                  <label
                    className="mb-1 mt-3 form_registrazione"
                    for="vecchiaPassword"
                  >
                    Vecchia Password
                  </label>
                  <ErrorMessage name="vecchiaPassword" component="h6" />
                  <Field
                    type="text"
                    className="form-control input_registrazione"
                    name="vecchiaPassword"
                    placeholder="Vecchia Password"
                  />
                </Fade>
              </Col>
              <Col>
                <Fade right>
                  <label
                    className="mb-1 mt-3 form_registrazione"
                    for="nuovaPassword"
                  >
                    Nuova Password
                  </label>
                  <ErrorMessage name="nuovaPassword" component="h6" />
                  <Field
                    type="text"
                    className="form-control input_registrazione"
                    name="nuovaPassword"
                    placeholder="Nuova Passoword"
                  />
                </Fade>
              </Col>
            </Row>
            <Button type="sumbit" className="mt-4" variant="success">
              Conferma
            </Button>
          </Form>
        </Formik>
      </Container>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </Container>
  );
}

export default ModificaPassword;
